<script>
    import {BAlert} from "bootstrap-vue";

    export default {
        name: 'NoResultsFound',
        functional: true,
        render(createElement, context) {
            return createElement(BAlert, {
                props: {
                    show: true,
                    variant: 'info',
                },
                class: "m-0 w-100",
                ...context.data
            }, [
                context.parent.$t('No results found')
            ])
        }
    }
</script>
